module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc16-c5b7454ba5199215277b8fd1b0f2fb87.jpg";